<video controls #myVideo style="width: 100%; border-radius: 5px">
    <source src="{{ linkVideo }}" type="{{ typeVideo }}" />
</video>
